module.exports = __webpack_public_path__ + "img/skype.916f53a8.svg";